import React from 'react';
import DateFnsUtils from '@date-io/date-fns';
import {ValidatorComponent} from 'react-material-ui-form-validator';
import {Box, withStyles} from '@material-ui/core';
import {styles} from './styles';
import {KeyboardDatePicker, MuiPickersUtilsProvider,} from '@material-ui/pickers';

/**
 * class to render keyboard date picker validator
 * @returns {JSX.Element}
 */
class KeyboardDatePickerValidator extends ValidatorComponent {
  renderValidatorComponent() {
    const {
      value,
      errorMessages,
      validators,
      validatorListener,
      ...rest
    } = this.props;

    return (
      <Box>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <KeyboardDatePicker {...rest} />
        </MuiPickersUtilsProvider>
        {this.errorText()}
      </Box>
    );
  }

  errorText() {
    const {isValid} = this.state;
    const {classes} = this.props;

    if (isValid) {
      return null;
    }

    return <Box className={classes.text}>{this.getErrorMessage()}</Box>;
  }
}

export default withStyles(styles)(KeyboardDatePickerValidator);
